import React from "react"
import { Grid, Button } from "@material-ui/core"
import styled from "styled-components"

const TextViewMoreWrapper = styled(Grid)`
  width: calc(100% - 20px);
  display: flex;
  position: relative;
  background: #302532;
  border-radius: 10px;
  flex-direction: column;
  code {
    width: calc(100% - 10px);
    color: #eeff8e;
    font-size: 14px;
    height: 40px;
    padding: 15px;
    text-wrap: wrap;
    transition: height 400ms ease;
    box-sizing: border-box;
    padding-top: 10px;
    word-wrap: break-word;
    min-width:300px;
    &.active {
      height: 200px;
      overflow: auto;
    }

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar {
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #de127f;
      border-radius: 10px;
    }
  }

  Button {
    background: transparent;
    color: #ffffff;
    font-weight: bold;
    text-decoration: underline;
    background: transparent;
    font-style: italic;
    margin: auto;
    margin-right: -1px;
    margin-top:30px;
  }
`

function ShowMore(props) {
  const { defaultValue = "", lengthWeight = 50 } = props || {}
  const [getIsShowMore, setIsShowMore] = React.useState(false)
  let isOverLength = defaultValue.length >= lengthWeight
  let cropText = isOverLength
    ? defaultValue.substring(0, lengthWeight).trim() + "..."
    : defaultValue

  return (
    <TextViewMoreWrapper>
      <code className={getIsShowMore ? "active" : ""}>
        {getIsShowMore ? defaultValue : cropText}

        {getIsShowMore && (
          <>
            <br />
            <br />
          </>
        )}
      </code>
      {isOverLength && (
        <Button
          onClick={() => {
            setIsShowMore(!getIsShowMore)
          }}
        >
          {getIsShowMore ? "Less" : "Show"}
        </Button>
      )}
    </TextViewMoreWrapper>
  )
}

export { ShowMore }
export default ShowMore
